import React, {PropTypes} from 'react';

export default function LessonDetailContent({content}) {
  return (
    <div dangerouslySetInnerHTML={{__html: content}} />
  );
}

LessonDetailContent.propTypes = {
  content: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/LessonDetailContent.js